import { Box, Grid } from '@mui/material';
import React, { useState } from 'react';
import CustomTextField from '../formFields/textField';
import LoaderButton from '../loaderButton/loaderButton';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { resetPasswordSchema } from 'src/config/yup';
import { USER_RESET_PASSWORD } from 'src/apiService/apiDeclaration';
import { showErrorTost, showSuccessTost } from 'src/constants';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

const ResetPasswordForm = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(resetPasswordSchema),
  });

  const changePass = async (body) => {
    setLoading(true);
    try {
      const resp = await USER_RESET_PASSWORD(body);
      showSuccessTost(resp.message);
      navigate('/');
    } catch (error) {
      showErrorTost(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: '100%', margin: '0 auto' }}>
      <form onSubmit={handleSubmit(changePass)}>
        <Grid sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <Grid item xs={12}>
            <CustomTextField
              label={t('resetPasswordPage.currentPass')}
              type="password"
              isPassword
              controller={{
                name: 'currentPass',
                control: control,
                errors: errors.currentPass,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              label={t('resetPasswordPage.newPass')}
              type="password"
              isPassword
              controller={{
                name: 'password',
                control: control,
                errors: errors.password,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              label={t('common.confirmPassword')}
              type="password"
              isPassword
              controller={{
                name: 'confirmPassword',
                control: control,
                errors: errors.confirmPassword,
              }}
            />
          </Grid>
          <Grid item xs={12} sx={{ mt: 2 }}>
            <LoaderButton
              type="password"
              loading={loading}
              variant="contained"
              disabled={!isValid}
              buttonText={t('resetPasswordPage.changePass')}
            />
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default ResetPasswordForm;
